class AccountBillingPaymentCtrl {

    static get $inject() {
        return ['$q', 'ModalService', '$scope', '$filter', 'PolicyService', '$stateParams', '$state', 'billing.AccountBillingDetailsService'];
    }

    constructor($q, ModalService, $scope, $filter, PolicyService, $stateParams, $state, AccountBillingDetailsService) {

        this.$onInit = () => {
            const tabStates = ['accounts.detail.billingAndPayment.billing', 'accounts.detail.billingAndPayment.payment'];

            this.tabIndex = $state.is(tabStates[1]) ? 1 : 0;
            this.billingSelected = this.tabIndex === 0;
            this.paymentSelected = this.tabIndex === 1;

            this.selectTab = (index) => {
                $state.go(tabStates[index]);
            };

            if (this.accountInfo.accountBillingSummary) {
                this.displayAddressArray = this.accountInfo.accountBillingSummary.primaryPayer.address.split(', ');
            }

            if ($stateParams.accountNumber) {
                this.billingInfoPromise = AccountBillingDetailsService.getAccountBillingDetails($stateParams.accountNumber);
            } else {
                this.billingInfoPromise = AccountBillingDetailsService.getAccountBillingDetails();
            }

            this.billingInfoPromise.then((result) => {
                this.billingInfo = result;

                if (this.billingInfo.paymentGroups.length > 0) {
                    this.billingInfo.paymentGroups.forEach((group) => {
                        PolicyService.getPolicySummariesFromPolicyNumbers(group.relatedPolicies)
                            .then((policySummaries) => {
                                group.relatedPolicies = policySummaries;
                            });
                    });
                }
            });
        };
    }

}

export default AccountBillingPaymentCtrl;
